import React from 'react';
import {Box, Divider, Tab, Tabs} from '@mui/material';

import {TAG_SCOPE} from '../../helpers/TagHelper';

const COLORS = {
    disabledTab: '#999999',
    selectedTab: '#000000',
};

const styles = {
    box: {
        tabsContainer: {
            alignItems: 'center',
            display: 'flex',
        }
    },
    divider: {
        backgroundColor: COLORS.selectedTab,
        height: '1rem',
        marginRight: '-0.5rem',
        marginTop: '1rem',
    },
    tabs: {
        root: {
            '& .MuiTab-root': {
                minWidth: 'auto',
            },
            '& .MuiTabs-flexContainer': {
                gap: '0rem',
            },
            margin: 0,
            marginLeft: '0rem',
            padding: 0,
        },
        tab: {
            '&.Mui-selected': {
                color: COLORS.selectedTab,
            },
            color: COLORS.disabledTab,
            fontSize: '1rem',
            textTransform: 'none',
        }
    }
};

export default function TagManagerTabs({scope, onScopeChange}) {
    return (
        <Box sx={styles.box.tabsContainer}>
            <Tabs value={scope} onChange={onScopeChange} TabIndicatorProps={{style: {display: 'none'}}} sx={styles.tabs.root}>
                <Tab label="Internal Tags" value={TAG_SCOPE.INTERNAL} sx={styles.tabs.tab}/>
                <Divider orientation="vertical" flexItem sx={styles.divider}/>
                <Tab label="External Tags" value={TAG_SCOPE.EXTERNAL} sx={styles.tabs.tab} disabled/>
            </Tabs>
        </Box>
    );
}